import { useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const categories = [
  {
    slug: "weddings",
    kicker: "Chapter I",
    title: "Weddings & Events",
    tagline: "The Cathedral of Light",
    image:
      "https://images.unsplash.com/photo-1671531776382-f32dff368120?crop=entropy&cs=srgb&fm=jpg&w=1600&q=85&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHw0fHxjaW5lbWF0aWMlMjB3ZWRkaW5nJTIwcGhvdG9ncmFwaHl8ZW58MHx8fHwxNzg0MjI5MjU2fDA&ixlib=rb-4.1.0",
  },
  {
    slug: "corporate",
    kicker: "Chapter II",
    title: "Corporate & Real Estate",
    tagline: "Architecture, held still",
    image:
      "https://images.unsplash.com/photo-1757356657991-c3fd6e2e812e?crop=entropy&cs=srgb&fm=jpg&w=1600&q=85&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjByZWFsJTIwZXN0YXRlJTIwYXJjaGl0ZWN0dXJlfGVufDB8fHx8MTc4NDIyOTI1Nnww&ixlib=rb-4.1.0",
  },
  {
    slug: "editorial",
    kicker: "Chapter III",
    title: "Creative Editorial",
    tagline: "Portraits with a spine",
    image:
      "https://images.pexels.com/photos/9514677/pexels-photo-9514677.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
  },
  {
    slug: "aerials",
    kicker: "Chapter IV",
    title: "Aerial Perspectives",
    tagline: "Notes from 400 feet",
    image:
      "https://images.unsplash.com/photo-1598774560778-a3b95285efa7?crop=entropy&cs=srgb&fm=jpg&w=1600&q=85&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwyfHxhZXJpYWwlMjBkcm9uZSUyMGxhbmRzY2FwZSUyMHN1bnNldHxlbnwwfHx8fDE3ODQyMjkyNTZ8MA&ixlib=rb-4.1.0",
  },
];

export default function PortfolioGrid({ compact = false }) {
  const [hover, setHover] = useState(null);

  return (
    <section
      className="relative bg-[var(--bg)] py-20 md:py-28 border-t border-white/5"
      data-testid="portfolio-grid"
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-12">
        {!compact && (
          <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-10 md:mb-14 gap-8">
            <div className="max-w-2xl">
              <div className="h-eyebrow mb-6">§ Selected Work</div>
              <h2 className="h-display text-4xl md:text-6xl leading-[0.95]">
                Four disciplines.<br/>
                <span className="italic font-serif-editorial text-[var(--gold)] font-light">One standard.</span>
              </h2>
            </div>
            <Link
              to="/portfolio"
              data-testid="portfolio-view-all"
              className="font-sans-display text-[11px] uppercase tracking-[0.3em] text-[var(--gold)] border-b border-[var(--gold)]/40 hover:border-[var(--gold)] pb-2"
            >
              View the full archive →
            </Link>
          </div>
        )}

        <div className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-10">
          {categories.map((c, i) => {
            // Asymmetric spans
            const spans = ["md:col-span-7", "md:col-span-5", "md:col-span-5", "md:col-span-7"];
            const heights = ["h-[70vh]", "h-[55vh]", "h-[55vh]", "h-[70vh]"];
            const offsets = ["", "md:mt-24", "", "md:mt-24"];
            const dim = hover !== null && hover !== i;
            return (
              <motion.div
                key={c.slug}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.15 }}
                transition={{ duration: 0.9, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
                className={`${spans[i]} ${offsets[i]}`}
                onMouseEnter={() => setHover(i)}
                onMouseLeave={() => setHover(null)}
              >
                <Link
                  to={`/portfolio#${c.slug}`}
                  className="block group"
                  data-testid={`portfolio-cat-${c.slug}`}
                >
                  <div className={`clip-frame ${heights[i]} bg-[#111] transition-all duration-700`} style={{ filter: dim ? "grayscale(0.9) brightness(0.55)" : "none" }}>
                    <img src={c.image} alt={c.title} loading="lazy" />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent pointer-events-none" />
                    <div className="absolute bottom-6 left-6 right-6 z-10 flex items-end justify-between">
                      <div>
                        <div className="numeral text-3xl mb-1 opacity-80">{c.kicker.split(" ")[1]}</div>
                        <div className="h-eyebrow text-[var(--ink)]/60">{c.kicker}</div>
                        <h3 className="font-sans-display text-2xl md:text-4xl font-light text-white mt-2">{c.title}</h3>
                      </div>
                      <div className="italic font-serif-editorial text-[var(--gold)] text-lg md:text-xl">
                        {c.tagline}
                      </div>
                    </div>
                  </div>
                </Link>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
